import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const deleteShippingConfig = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminShippingConfig/deleteShippingConfig',
    method: 'DELETE',
    params,
  });

export { deleteShippingConfig };
